module.exports = __webpack_public_path__ + "img/transfer.8c470842.svg";